<script>
import * as m from '@app/paraglide/messages.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
import {
    historyState, insertHistoryAction, resetHistory
} from '@app/store/historyStore.svelte.js';
import { createEventDispatcher} from 'svelte';
import removeEvent from '@cclib/functions/eventGroups/removeEvent.js';
import Swal from 'sweetalert2';
import { SWAL_BASE, SWAL_CLASSES } from '@app/lib/swalClasses.js';

const dispatch = createEventDispatcher();
async function deleteEvents() {
    try {
        const eventsToDelete = eventGroupState[projectState.selected].selected.length;
        
        // Show confirmation dialog
        const result = await Swal.fire({
            ...SWAL_BASE,
            customClass: SWAL_CLASSES.destructive,
            title: m.context_menu_delete_title(),
            text: m.context_menu_delete_text({count: eventsToDelete}),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: m.context_menu_delete_confirm(),
            cancelButtonText: m.context_menu_delete_cancel(),
        });
        
        // If user cancels, return early
        if (!result.isConfirmed) {
            return;
        }
        
        // Continue with deletion if confirmed
        eventGroupState[projectState.selected].selected.sort((a, b) => {
            return b - a;
        });

        let lastEvent = eventGroupState[projectState.selected].selected[eventGroupState[projectState.selected].selected.length-1]-1;

        eventGroupState[projectState.selected].selected.forEach(eventIndex => {
            eventGroupState[projectState.selected] = removeEvent(eventGroupState[projectState.selected], eventIndex);
        });

        
        eventGroupState[projectState.selected].selected = lastEvent >= 0 ? [lastEvent] : [];

        toast.push(m.context_menu_delete_success_toast(), {classes: ["toast-success"]});

        insertHistoryAction({
            name: "remove event(s)", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    } catch(err){
        console.log(err);
        console.log(err.message);
    } finally {
        dispatch("done");
    }
}
</script>

<a id="btnDeleteEvents"
   role="menuitem"
   aria-label={m.context_menu_delete_label()}
   class="dropdown-item" href="#!/"
   onclick={deleteEvents}>
   {m.context_menu_delete()}
</a>
